// frontend/src/api/saved.js
import { apiClient } from './index';

const savedApi = {
  /**
   * Get all saved items for the user
   */
  getSavedItems: async () => {
    return await apiClient.get('/saved/');
  },

  /**
   * Toggle save status (Save/Unsave)
   * @param {string} itemId 
   * @param {string} itemType - 'vehicle' or 'part'
   */
  toggleSaved: async (itemId, itemType = 'vehicle') => {
    return await apiClient.post('/saved/toggle', {
      item_id: itemId,
      item_type: itemType
    });
  },

  /**
   * Check if a specific item is saved
   * @param {string} itemId 
   */
  checkSavedStatus: async (itemId) => {
    return await apiClient.get(`/saved/check/${itemId}`);
  }
};

export { savedApi };